import { Check } from 'lucide-react';

export const FinishPicker = ({ finishes, value, onChange, prefix }) => <div className="finish-picker" role="group" aria-label="Frame color" data-testid={`${prefix}-picker`}>
  {finishes.map(finish => <button type="button" key={finish.id} data-testid={`${prefix}-${finish.id}`} title={`${finish.name || finish.label} · ${finish.code}`} aria-pressed={value === finish.id} onClick={() => onChange(finish.id)}>
    <span className="finish-picker-swatch" style={{ backgroundColor: finish.hex }}>{value === finish.id && <Check size={15} aria-hidden="true" />}</span>
    <span>{finish.name || finish.label}</span>
  </button>)}
</div>;